import "./complianceHome.scss";

import CardHomeAdmin from "../../../components/card-home-admin/cardHomeAdmin";
import ListHomeAdmin from "../../../components/custom-list/custom-list";
import { useEffect, useMemo, useState } from "react";
import OrgEntries from "../../../components/organization-entries-list/org-entries";
import Identities from "../identities/identities";
import Blocked from "../blocked/blocked";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { fetchLatest } from "../../../store/ReceiptsSlice";
import { fetchClientsByOrganization } from "../../../store/UserSlice";

const ComplianceHome = () => {

    const dispatch = useAppDispatch()

    const latestDeposits = useAppSelector((state) => state.receipts.latestDeposits);
    const clients = useAppSelector((state) => state.user.clientList);

    const [type,setType] = useState<string>('deposits');

    const totalDeposits = useMemo(() => {
        if (!latestDeposits?.data) return 0;
        return latestDeposits.data.reduce((sum: number, d: any) => sum + Number(d.value || 0), 0);
    }, [latestDeposits]);

    useEffect( () => {
        dispatch( fetchLatest('all') )
        dispatch( fetchLatest('invoices') )
        dispatch( fetchLatest('deposits') )
        dispatch( fetchLatest('purchases') )
        dispatch( fetchLatest('payments') )
        dispatch( fetchClientsByOrganization() )
    }, [dispatch])

    return (
        <div className="compliance-home">
            
            <div className="header">

                <div className="left">

                    <h1 className="page-title">
                        Compliance
                        <small>Procure por identidades ou verifique os status das transacoes</small>
                    </h1>
                    <div className="buttons">
                        <div className="btn ghost" onClick={() => setType('deposits')}>Lista de depositos</div>
                        <div className="btn ghost" onClick={() => setType('search')}>Procurar Identidades</div>
                        <div className="btn ghost" onClick={() => setType('blocked')}>Lista de Pessoas Bloqueadas</div>
                    </div>

                </div>
                <div className="right">
                    <div className="compliance-card">
                        <div className="card-row">
                            <span className="card-label">Total Depositos</span>
                            <span className="card-value deposits">{totalDeposits.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                        </div>
                        <div className="card-row">
                            <span className="card-label">Quantidade Depositos</span>
                            <span className="card-value">{latestDeposits?.data?.length || 0}</span>
                        </div>
                        <div className="card-row">
                            <span className="card-label">Usuarios</span>
                            <span className="card-value">{clients?.length || 0}</span>
                        </div>
                    </div>
                </div>

            </div>
            
            { type === 'deposits' && (
                <OrgEntries />
            )}
            { type === 'search' && (
                <Identities />
            )}
            { type === 'blocked' && (
                <Blocked />
            )}

        </div>
    );  
}

export default ComplianceHome;